import PropTypes from 'prop-types'
import { NextSeo } from 'next-seo'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Hero from '@components/hero'
import RenderRichText from '@components/renderers/render-rich-text'
import defaults from '@config/defaults'
import useStyles from './contact.styles'
import Button from '@material-ui/core/Button'
import { useEffect } from 'react'

const Contact = (props) => {
  const {
    addressEyebrow,
    addressHeadline,
    address1,
    address2,
    phone,
    body,
    headline,
    heroImage,
    heroText,
    metaTitle,
    metaImage,
  } = props
  const styles = useStyles()

  useEffect(() => {
    window.Intercom('update', {
      hide_default_launcher: true
    });
  }, []); 

  return (
    <div className={styles.root}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaTitle}
        canonical={`${defaults.baseUrl}contact`}
        openGraph={{
          title: metaTitle,
          type: 'website',
          url: `${defaults.baseUrl}contact`,
          images: [{ url: metaImage && metaImage.url }],
        }}
      />

      {heroImage && (
        <Hero
          background={heroImage}
          heroText={heroText}
        />
      )}

      <Container className={styles.container}>
        {!heroImage && <Typography variant="h3" component="h1" className={styles.contactTitle}>{heroText}</Typography>}
        <Grid container>
          <Grid item xs={12} md={7}>
            <Typography variant="h5" gutterBottom>{headline}</Typography>
            <div className={styles.richText}>
              <RenderRichText {...body} />
            </div>
            <Button variant="contained" color="primary" style={{ marginTop: '20px' }} >
              Contact Us
            </Button>
          </Grid>
          <Grid container item xs={12} md={5} alignItems="center" justifyContent="center">
            <div className={styles.addressContainer}>
              <Typography variant="overline" color="primary" gutterBottom>{addressEyebrow}</Typography>
              <Typography variant="h5" gutterBottom>{addressHeadline}</Typography>
              <Typography variant="body2">{address1}</Typography>
              <Typography variant="body2" gutterBottom>{address2}</Typography>
              <Typography variant="body2">{phone}</Typography>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

Contact.propTypes = {
  addressEyebrow: PropTypes.string,
  addressHeadline: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  phone: PropTypes.string,
  acceptMessage: PropTypes.shape({}),
  messageSuccess: PropTypes.string,
  messageError: PropTypes.string,
  body: PropTypes.shape({}),
  heroImage: PropTypes.shape({}),
  heroText: PropTypes.string,
  headline: PropTypes.string,
  metaImage: PropTypes.shape({
    url: PropTypes.string,
  }),
  metaTitle: PropTypes.string,
}

Contact.defaultProps = {}

export default Contact
